export const ABM = 'abm';
export const ACCOUNTING = 'accounting';
export const ANALYTICS = 'analytics-data';
export const AUTOMATION = 'marketing-automation';
export const CALL_CENTER = 'calling';
export const CMS = 'cms';
export const CRM = 'crm';
export const CUSTOMER_SUCCESS = 'customer-success';
export const DATA_MANAGEMENT = 'data-management';
export const ECOMMERCE = 'ecommerce';
export const EMAIL = 'email';
export const EMPLOYEE_ENGAGEMENT = 'employee-engagement';
export const ERP = 'erp';
export const EVENT = 'events';
export const FIELD_SERVICE_MANAGEMENT = 'field-service-management';
export const HELP_DESK = 'help-desk';
export const IPAAS = 'connector';
export const KNOWLEDGE_BASE = 'knowledge-base';
export const LEAD_GEN = 'lead-generation';
export const LEARNING_MANAGEMENT_SYSTEM = 'learning-management-system';
export const LIVE_CHAT = 'live-chat';
export const PARTNER_RELATIONSHIP_MANAGEMENT = 'partner-relationship-management';
export const PAYROLL = 'payroll';
export const PPC = 'advertising';
export const PROJECT = 'project-management';
export const SALES = 'sales-enablement';
export const SCHEDULING = 'scheduling';
export const SEO = 'seo';
export const SOCIAL = 'social-media';
export const SURVEY = 'survey';
export const TICKETING = 'ticketing';
export const VIDEO = 'video';
export const WEBINAR = 'webinar';
export const WEBSITE = 'website-builder';
export const WORDPRESS = 'wordpress';
export const WORKFLOW = 'workflow-automation';